import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=d63f90f2"
import script from "./Color.vue?vue&type=script&lang=ts"
export * from "./Color.vue?vue&type=script&lang=ts"
import style0 from "./Color.vue?vue&type=style&index=0&id=d63f90f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports